import React, { useEffect } from 'react';
import './Hero.css';
import '../Header.css';
import services from '../../../../services';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@mui/material';
const useStyles = makeStyles({
  container: {
    ['@media(max-width:768px)']: {
      display: 'block',
    },
  },
  secdiv: {
    // row align-items-center h-100
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    height: '100%',
  },
});
function Hero2(props) {
  const classes = useStyles();
  //const { currentPhraseIndex, onEnd } = props;
  function n3xt(text, element) {
    let sample = document.querySelector(element);
    if (sample != null) {
      if (sample.dataset.animating === 'true') return;
      let sampleH = 50;
      let sampleT = sample.textContent;
      let sampleNT = text;
      sample.dataset.animating = 'true';
      sample.style.height = sampleH + 'px';
      let samO = document.createElement('div');
      samO.style.transformOrigin =
        '0 ' + sampleH / 2 + 'px -' + sampleH / 2 + 'px';
      samO.classList.add('t3xt');
      samO.textContent = sampleT;
      let samN = samO.cloneNode();
      samN.textContent = sampleNT;
      sample.textContent = '';
      sample.appendChild(samO);
      sample.appendChild(samN);
      samO.classList.add('t3xt-out');
      samN.classList.add('t3xt-in');
      samN.addEventListener('animationend', function (event) {
        sample.removeChild(samO);
        sample.removeChild(samN);
        sample.textContent = sampleNT;
        sample.dataset.animating = 'false';
      });
    }
  }

  useEffect(() => {
    const t3xts = services.map((el) => [el.title, el.example1, el.example2]);

    let phraseIndex = 0;
    let wordIndex = 0;
    let index;
    function changetext() {
      if (wordIndex > 2) {
        wordIndex = 0;
        phraseIndex++;
      }
      if (phraseIndex >= t3xts.length) {
        phraseIndex = 0;
      }
      let term = t3xts[phraseIndex][wordIndex];
      n3xt(term, '.t3xt-' + ++wordIndex);

      if (wordIndex === 3) {
        index = setTimeout(changetext, 2500);
      } else {
        index = setTimeout(changetext, 1000);
      }
    }
    index = setTimeout(changetext, 1500);
    return () => {
      clearTimeout(index);
    };
  }, []);
  return (
    <div className="hero-2">
      <Container fixed className={`${classes.container} h-hunvh cube-box`}>
        <div className={`${classes.secdiv}`}>
          <Grid
            xs={12}
            md={9}
            lg={7}
            xl={6}
            //  className="col-12 col-md-9 col-lg-7 col-xl-6"
          >
            <div className="caption animated fadeIn cube">
              {/* animated fadeIn cube */}
              <div className="t3xts t3xt-1"></div>
              <div className="t3xts t3xt-2"></div>
              <div className="t3xts t3xt-3"></div>
            </div>
          </Grid>
        </div>
      </Container>
    </div>
  );
}

export default Hero2;
